module.exports = __webpack_public_path__ + "static/about-893a81d1caa120ce2cf64b4c6cd613b9.jpg";